<template>
	<li :class="{ active, primary }">
		<NuxtLink :to="to">
			<UiIcon v-if="icon" :name="icon" />
		</NuxtLink>
		<span v-if="title && !primary">{{ title }}</span>
	</li>
</template>

<script lang="ts" setup>
interface Props {
	to?: string;
	icon?: string;
	title?: string;
	active?: boolean;
	primary?: boolean;
}

withDefaults(defineProps<Props>(), {
	active: false,
	primary: false,
});
</script>
